import React from 'react';

const ProblemSection = ({ data }) => {
  return (
    <section className="p-80px-tb problem-section bg-light">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center m-50px-b">
            <h2 className="section-title font-weight-bold m-20px-b">{data.title}</h2>
            <p className="lead text-muted">{data.subtitle}</p>
          </div>
        </div>
        <div className="row">
          {data.cards.map((card, index) => (
            <div key={index} className="col-lg-4 col-md-6 m-30px-b">
              <div className="card h-100 shadow-sm hover-shadow transition">
                <div className="card-body p-40px">
                  <div className="feature-icon m-25px-b">
                    <i className={`${card.icon} icofont-3x text-primary`}></i>
                  </div>
                  <h4 className="font-weight-bold m-20px-b">{card.title}</h4>
                  <p className="text-muted">{card.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;